import React from 'react'

const TrustedByMany = () => {
    return (
        <div className="bg-primary-dark2  relative text-white overflow-hidden flex flex-col lg:flex-row justify-between py-20 md:px-24 px-4">
            <h2 className='text-center text-2xl md:text-5xl lg:text-7xl lg:text-start max-w-xs md:max-w-full mx-auto font-semibold'>
                <span className='text-primary font-light'>Trusted by </span>
                Educators, Founders & Visionaries
            </h2>

            <div className='flex flex-col justify-center items-center lg:items-start mt-8'>
                <img src="/assets/trust.png" alt="Check" className='w-28' />
                <p className='text-center lg:text-start mt-6 text-sm max-w-md md:max-w-full font-medium md:text-xl'>
                    At Everest Apps, we empower start-ups, individuals, and organisations, collaborating with hundreds of Australian schools, government entities, charities, and international clients. Let's ascend the summit of technology together.
                </p>
            </div>
        </div>
    )
}

export default TrustedByMany